export const FETCH_FOLDERS = 'documentsActions/FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'documentsActions/FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_FAILED = 'documentsActions/FETCH_FOLDERS_FAILURE';

export const CREATE_FOLDER = 'documentsActions/CREATE_FOLDER';
export const CREATE_FOLDER_SUCCESS = 'documentsActions/CREATE_FOLDER_SUCCESS';
export const CREATE_FOLDER_FAILED = 'documentsActions/CREATE_FOLDER_FAILURE';

export const FETCH_FOLDER = 'documentsActions/FETCH_FOLDER';
export const FETCH_FOLDER_SUCCESS = 'documentsActions/FETCH_FOLDER_SUCCESS';
export const FETCH_FOLDER_FAILED = 'documentsActions/FETCH_FOLDER_FAILURE';

export const FETCH_SINGLE_FOLDER = 'documentsActions/FETCH_SINGLE_FOLDER';
export const FETCH_SINGLE_FOLDER_SUCCESS =
  'documentsActions/FETCH_SINGLE_FOLDER_SUCCESS';
export const FETCH_SINGLE_FOLDER_FAILED =
  'documentsActions/FETCH_SINGLE_FOLDER_FAILURE';

export const DELETE_FOLDER = 'documentsActions/DELETE_FOLDER';
export const DELETE_FOLDER_SUCCESS = 'documentsActions/DELETE_FOLDER_SUCCESS';
export const DELETE_FOLDER_FAILED = 'documentsActions/DELETE_FOLDER_FAILURE';

export const UPDATE_FOLDER = 'documentsActions/UPDATE_FOLDER';
export const UPDATE_FOLDER_SUCCESS = 'documentsActions/UPDATE_FOLDER_SUCCESS';
export const UPDATE_FOLDER_FAILED = 'documentsActions/UPDATE_FOLDER_FAILURE';

export const UPDATE_FILE = 'documentsActions/UPDATE_FILE';
export const UPDATE_FILE_SUCCESS = 'documentsActions/UPDATE_FILE_SUCCESS';
export const UPDATE_FILE_FAILED = 'documentsActions/UPDATE_FILE_FAILURE';

export const ADD_FILE = 'documentsActions/ADD_FILE';
export const ADD_FILE_SUCCESS = 'documentsActions/ADD_FILE_SUCCESS';
export const ADD_FILE_FAILED = 'documentsActions/ADD_FILE_FAILURE';

export const MOVE_FOLDER = 'documentsActions/MOVE_FOLDER';
export const MOVE_FOLDER_SUCCESS = 'documentsActions/MOVE_FOLDER_SUCCESS';
export const MOVE_FOLDER_FAILED = 'documentsActions/MOVE_FOLDER_FAILURE';

export const COPY_FOLDER = 'documentsActions/COPY_FOLDER';
export const COPY_FOLDER_SUCCESS = 'documentsActions/COPY_FOLDER_SUCCESS';
export const COPY_FOLDER_FAILED = 'documentsActions/COPY_FOLDER_FAILURE';

export const FILES_INFO = 'documentsActions/FILES_INFO';
export const FILES_INFO_SUCCESS = 'documentsActions/FILES_INFO_SUCCESS';
export const FILES_INFO_FAILED = 'documentsActions/FILES_INFO_FAILURE';
export const CHANGE_STATE = 'documentsActions/CHANGE_STATE';

export const FETCH_ICONS = 'documentsActions/FETCH_ICONS';
export const FETCH_ICONS_SUCCESS = 'documentsActions/FETCH_ICONS_SUCCESS';
export const FETCH_ICONS_FAILED = 'documentsActions/FETCH_ICONS_FAILURE';

export function fetchFolders(filters) {
  return {
    type: FETCH_FOLDERS,
    filters,
  };
}

export function fetchFoldersSuccess(folders, total) {
  return {
    type: FETCH_FOLDERS_SUCCESS,
    folders,
    total,
  };
}

export function fetchFoldersFailed(err) {
  return {
    type: FETCH_FOLDERS_FAILED,
    err,
  };
}

export function createFolder(companyId, details, filters) {
  return {
    type: CREATE_FOLDER,
    details,
    filters,
    companyId,
  };
}

export function changeState() {
  return {
    type: CHANGE_STATE,
  };
}

export function createFolderSuccess(pageFolder) {
  return {
    type: CREATE_FOLDER_SUCCESS,
    pageFolder,
  };
}

export function createFolderFailed(error) {
  return {
    type: CREATE_FOLDER_FAILED,
    error,
  };
}

export function deleteFolder(folderId) {
  return {
    type: DELETE_FOLDER,
    folderId,
  };
}

export function deleteFolderSuccess(folder) {
  return {
    type: DELETE_FOLDER_SUCCESS,
    folder,
  };
}

export function deleteFolderFailed(err) {
  return {
    type: DELETE_FOLDER_FAILED,
    err,
  };
}

export function updateFolder(folderId, details, action) {
  return {
    type: UPDATE_FOLDER,
    folderId,
    details,
    action,
  };
}

export function updateFolderSuccess(folder) {
  return {
    type: UPDATE_FOLDER_SUCCESS,
    folder,
  };
}

export function updateFolderFailed(err) {
  return {
    type: UPDATE_FOLDER_FAILED,
    err,
  };
}

export function fetchFolder(folderId) {
  return {
    type: FETCH_FOLDER,
    folderId,
  };
}

export function fetchFolderSuccess(folder) {
  return {
    type: FETCH_FOLDER_SUCCESS,
    folder,
  };
}

export function fetchFolderFailed(err) {
  return {
    type: FETCH_FOLDER_FAILED,
    err,
  };
}

export function addFile(file, isChatFile) {
  return {
    type: ADD_FILE,
    isChatFile,
    file,
  };
}

export function addFileSuccess(pageFolder) {
  return {
    type: ADD_FILE_SUCCESS,
    pageFolder,
  };
}

export function addFileFailed(error) {
  return {
    type: ADD_FILE_FAILED,
    error,
  };
}

export function updateFile(fileId, details) {
  return {
    type: UPDATE_FILE,
    fileId,
    details,
  };
}

export function updateFileSuccess(folder) {
  return {
    type: UPDATE_FILE_SUCCESS,
    folder,
  };
}

export function updateFileFailed(err) {
  return {
    type: UPDATE_FILE_FAILED,
    err,
  };
}

export function moveFolder(folderId, moveFolderId, categoryType) {
  return {
    type: MOVE_FOLDER,
    folderId,
    moveFolderId,
    categoryType,
  };
}

export function moveFolderSuccess(folder) {
  return {
    type: MOVE_FOLDER_SUCCESS,
    folder,
  };
}

export function moveFolderFailed(err) {
  return {
    type: MOVE_FOLDER_FAILED,
    err,
  };
}

export function copyFolder(folderId) {
  return {
    type: COPY_FOLDER,
    folderId,
  };
}

export function copyFolderSuccess() {
  return {
    type: COPY_FOLDER_SUCCESS,
  };
}

export function copyFolderFailed(err) {
  return {
    type: COPY_FOLDER_FAILED,
    err,
  };
}

export function filesInfo(companyId) {
  return {
    type: FILES_INFO,
    companyId,
  };
}

export function filesInfoSuccess(info) {
  return {
    type: FILES_INFO_SUCCESS,
    info,
  };
}

export function filesInfoFailed(err) {
  return {
    type: FILES_INFO_FAILED,
    err,
  };
}

export function addUploadedFile(file) {
  return {
    type: ADD_FILE_SUCCESS,
    file,
  };
}

export function fetchIcons(filters) {
  return {
    type: FETCH_ICONS,
    filters,
  };
}

export function fetchIconsSuccess(folders) {
  return {
    type: FETCH_ICONS_SUCCESS,
    folders,
  };
}

export function fetchIconsFailed(err) {
  return {
    type: FETCH_ICONS_FAILED,
    err,
  };
}
